const setItem = (key, value) => {
  localStorage.setItem(key, value);
};

const getItem = (key, defaultValue) => {
  return localStorage.getItem(key) || defaultValue;
};

export { setItem, getItem };
